const cancel = 'キャンセル'
const save = '保存'

export default {

  global: {
    generalError: '残念！リクエストを処理できませんでした。ページの再読み込みを行って下さい。',
    signature: '以上、よろしくお願いいたします。',
  },

  component: {
    actionBar: {
      actions: 'アクション',
      hideActions: 'アクションを非表示',
    },

    addButton: {
      add: '追加',

    },

    supportLink: 'support@recright.com',

    attachments: {
      add: '履歴書またはその他の必要な添付書類を追加して下さい。',
      placeholderWithDescription: '要求された添付ファイルを追加する',
      remove: '削除',
      allowedFileTypes: '許可されたファイル形式',
      errors: {
        size: 'ファイルが大きすぎます。ファイルの許容サイズは5MBまでです。',
        empty: 'ファイルにデータがありません',
        invalidType: fileType => `申し訳ございません。セキュリティの理由から${fileType}ファイルはアップロードできません。`,
        typeNotWhitelisted: '申し訳ありませんが、ファイル形式は許可できるものではありません。',
      },
    },

    agreeTos: {
      privacyLinkText: 'プライバシーポリシー’をお読みになり',
      termsLinkText: '利用規約’も読み、同意した上で ',
      privacyPolicyText: '当社ではお客様のプライバシーを大切にしています。当社の ',
      termsText1: 'お客様の個人情報をご提供される前に',
      termsText2: 'を読んで承諾してください。',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `弊社があなたの個人データを処理することを希望しない場合は、メールで${mail}宛に個人データの削除を依頼して下さい。`,
      customSupportPrivacyInfo: link => `個人データの処理を希望しない場合は、${link} に連絡して削除の申し出ができます。`,
    },

    buttons: {
      close: '閉じる',
    },

    competencies: {
      addCompetency: '新しい能力を追加する',
      edit: '能力を編集する',
      done: '完了',
      defaultsDescription: '使用する適格性が不明な場合は、こちらで設定したデフォルトをご利用いただけます。',
      getDefaults: '既定の適格性を求人広告に入れる',
    },

    competency: {
      warning: '能力とその評価をすべて削除しますか?',
    },

    confirmDelete: {
      delete: '削除',
      cancel: 'キャンセル',
      confirm: '確認',
    },

    confirm: {
      cancel: 'テイクの削除',
      confirm: '再試行',
    },

    confirmButton: {
      wait: count => `待機${count}`,
      confirm: '確認',
    },

    controlStatus: {
      text: {
        empty: '入力',
        valid: () => '準備完了',
      },
      textarea: {
        empty: '入力',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'セット',
        valid: () => '準備完了',
      },
      file: {
        empty: '選択',
        valid: () => '変更',
      },
      list: {
        empty: '追加',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: '検索する',
        valid: () => '準備完了',
      },
    },

    cookieConsentModal: {
      title: '当社のWebサイトはクッキーを使用しています',
      body: 'すべてのクッキーを受け入れることで、サイトナビゲーションの強化、サイトの利用状況の分析、マーケティングの取り組みの支援のために、デバイスにクッキーが保存されることに同意したことになります',
      learnMoreLinkText: 'クッキーの使用方法についての詳細',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'クッキーの管理',
      acceptAll: 'すべてのクッキーを受け入れる',
      manageTitle: '同意設定の管理',
      necessaryCookiesTitle: '不可欠なクッキー',
      necessaryCookiesBody:
        'これらのクッキーは、Webサイトを機能させる上で不可欠であり、システムでオフにすることはできません。',
      performanceCookiesTitle: 'パフォーマンスクッキー',
      performanceCookiesBody:
        'これらのクッキーを使用すると訪問数とトラフィックの発信元をカウントできるため、サイトのパフォーマンスの測定と改善に役立ちます。',
      confirmChoices: '自分の選択を確認する',
      marketingCookiesTitle: 'マーケティングクッキー',
      marketingCookiesBody:
        'これらのCookieを使用すると、広告をカスタマイズし広告の効果を評価することができます。',
      functionalCookiesTitle: '機能性Cookie',
      functionalCookiesBody:
        'これらのCookieは、Webサイトの機能性の強化に使用されます。これらのCookieがないと、特定の機能性が利用できなくなることがあります。機能性Cookieの例としては、Webチャットサービスやユーザー設定などがあげられます。',
    },

    emailAddresses: {
      remove: '削除する',
      importCsv: 'Import CSV',
      invalidEmails: '無効なメールアドレスが見つかりました。',
      maxCsvEntryErrorNotification: amount =>
        `エントリの最大許容量は ${amount} csv です。`,
      importCsvTooltip:
        'CSV行には、電子メールアドレス、または電子メールアドレスと電話番号の両方を記入できます。各行は受信者を表しています。電話番号は必ず国際形式（E.164）にしてください。例： <strong>+358</strong>50xxxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'メールが戻ってきました。受信者がメッセージを受信したことを確認してください。',
      },
      Permanent: {
        General: 'メールを送信できませんでした。受信者側の電子メールプロバイダーによってメッセージが拒否されました。',
        NoEmail: 'メールアドレスは存在しません。',
        Suppressed: 'すでに数回の送信に失敗しているため、メールを送信できませんでした。',
      },
      Transient: {
        General: 'メールが戻ってきました。受信者がメッセージを受信したことを確認してください。',
        MailboxFull: '受信者の受信トレイがいっぱいです。',
        MessageTooLarge: 'メッセージのサイズが大きすぎます。',
        ContentRejected: 'メッセージの内容が拒否されました。',
        AttachmentRejected: '添付ファイルが拒否されました。',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'この電話番号はすでに他のインタビュー候補者に登録されています。',
    },

    error403: {
      heading: 'アクセス禁止',
      content: '正しいアカウントにログインし、Recrightでこのポジションを見直す招待を受けているか確認してください。また、単一のブラウザウィンドウで同時にRecrightを使用していることも確認してください。',
      link: 'フロントページ',
    },

    error404: {
      heading: '何もありません',
      content: '探しましたが、要求されたアドレスにはウェブページがありませんでした。すでに期限切れのリンクを使用したか、アドレスを誤って入力した可能性があります。',
      link: 'フロントページ',
    },

    error410: {
      heading: '非公開',
      content: '求人情報は非公開または応募期間が終了しているため、表示できません。',
      link: 'フロントページ',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: '初期化しています…',
      connection_error_hint: 'ネットワークに接続できませんでした。',
      permission_hint: 'サイトにウェブカメラとマイクへのアクセスを許可して下さい。',
      searching_camera_hint: 'ウェブカメラを検索中…',
      camera_reserved_hint: '他のアプリまたはウェブページでウェブカメラが使用されています。\nアプリを終了し、このページの再読み込みを行って下さい。',
      camera_reserved_hint_chrome_extra: 'Chromeを使用している場合は、アドレスバーの下のダイアログからRecrightにウェブカメラの使用許可を出してください。',
      no_camera_hint: 'ウェブカメラが見つかりませんでした。',
      no_mic_hint: 'マイクが見つかりませんでした。',
      uploading_text: 'アップロード中...',
      rtmpt_in_use: 'あなたのネットワーク管理者がRTMPを許可した場合、このステップは必要ありません。詳細は弊社までお問い合わせください。',
      preview_text: 'ウェブカメラは現在プレビューモードです',
      close_text: 'カメラを閉じる',
      remove_text: 'テイクを削除する',
      noflash_errortext_install: link => `Adobe Flash Playerがインストールされていないようです。動画を録画するにはFlashのプラグインが必要です。こちらで入手して下さい：${link}`,
      noflash_errortext_enable: link => `Flashをインストールした後もこのメッセージが表示される場合は、こちらをご覧ください：${link}`,
      noflash_errortext_differentbrowser: 'HTML5での録画をサポートしているブラウザを利用する方法もあります。弊社ではChromeかFirefoxを推奨しています。',
    },

    footer: {
      terms: '使用条件',
      license: 'Recright一般利用規約を',
      privacyPolicy: 'プライバシーポリシー',
      customSupport: link => `連絡先 ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'この面接について評価をしてください。',
      howWouldYouRateJobAd: '今回のあなたの応募の経験について、評価をしてください。',
      yourResponseIsAnonymous: 'この回答は匿名になります。',
      thankYouFeedback: 'ご回答をありがとうございます。',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: '申し訳ありませんが、ファイル形式は許可できるものではありません。',
      isRequired: 'このフィールドは必須です。',
      isEmail: value => `${value}は無効なメールアドレスです。`,
      isDate: value => `${value}は無効な日付です。`,
      invalidUrl: 'URLが有効ではありません。',
      singleHireEndError: '個別の求人は60日を超えて利用することが出来ません。',
      isNotTooOldForLive: '過去の日付です。',
      isNotAfterEndDate: '公開日は求人広告締切日より早い日付を選択してください。',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: '電話番号はすでに追加されています。',
      duplicateCompetency: 'この名前に関する適格性はすでに存在します。',
      isNotDuplicateTemplateName:
        'その名前のメールテンプレートはすでに存在する。',
    },

    jobAdApplication: {
      name: 'お名前',
      email: 'Eメール',
      phone: '電話番号',
      city: '居住都市',
      applyForPosition: '応募する',
      back: '戻る',
      continue: '続ける',
      submit: '提出する',
      saveForLater: '後で再開する',
      namePlaceholder: 'お名前を入力してください。',
      emailPlaceholder: 'Eメールを入力してください。',
      phonePlaceholder: '電話番号を入力してください。',
      cityPlaceholder: '現在の居住都市を入力してください。',
      links: 'LinkedInプロフィール等、参照リンクを入力してください。',
      legendBasicInfo: '基本情報',
      legendLinks: '参照リンク',
      legendAttachments: '添付ファイル',
      legendAdditionalFields: '追加情報',
      coverLetter: 'PRメッセージ・カバーレター',
      attachments: '添付ファイル',
      introduction: '簡単な自己紹介文をご記入ください。',
      thankYou: 'ありがとうございます。',
      luck: 'ご成功をお祈りしています!',
      close: '閉じる',
      required: '*マークが付いた項目は必須入力です。',
    },

    jobAdContainer: {
      endTime: date => (date ? `締切日: ${date}` : ''),
    },

    jobAdDetails: {
      apply: '応募する',
    },

    jobAdQuickInterview: {
      title: 'クイックビデオ設問',
      back: '戻る',
      continue: '続ける',
      submit: '提出する',
      saveForLater: '後で再開する',
      description: 'あなたのことをスピーディに知るために、質問に簡潔にご回答ください。あなたのお人柄や応募の熱意を表してご回答いただけたら嬉しく思います。',
      requiredNote: 'まだ応募プロセスは完了していません。ご回答の録画を終えることで初めてご応募完了となります。',
      reminderNote: '今すぐに設問への回答を録画することができます。また、後ほどリマインドメールが送信されますので、その際に録画を追加（応募再開）することも可能です。',
    },

    jobAdRow: {
      responses: '応募',
      status: {
        open: '募集中',
        filled: '定員に達しました',
        cancelled: '取消されました',
        done: '完了',
        close: '終了',
        draft: '終了（下書き）',
        hidden: '非表示',
      },
    },

    interviewRow: {
      responses: '候補者',
    },

    loadingButton: {
      loading: '読み込み中…',
      saving: '保存中…',
      sending: '送信中…',
    },

    modalApplicationForm: {
      applyForPosition: '求人に応募する',
      continue: '次へ',
      name: '氏名を入力して下さい',
      email: 'メールアドレスを入力して下さい',
      phoneNumber: '電話番号を入力して下さい',
      links: 'リンクを入力できます',
      legendLinks: 'リンク',
      legendAttachments: '添付',
      coverLetter: 'カバーレター',
      attachments: '添付',
      introduction: '自己紹介を記入してください',
      thankYou: 'ありがとうございました。',
      luck: '幸運をお祈りします！',
      close: '閉じる',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: '閉じる',
    },

    modalLinkShare: {
      title: '共有できる公開リンク',
      info: '共有可能な求人広告の公開アドレスです。\nご関心のある方は、誰でも求人広告を見て応募することが出来ます。\n応募者が集まり始めると、通常の通知が届きます。\n\n以下が求人広告の公開リンクです：',
    },

    modalVideoAdd: {
      title: '新しい動画を追加する',
      chooseTitle: '新しい動画を追加する',
      titlePlaceholder: '動画のタイトルを入力する',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: '新しい動画をアップロードする',
      info: '許容できる動画の最大サイズは500MBです。できればアップロード前に動画を圧縮し、アップロード時間と変換時間を減らしましょう。',
    },

    modalCandidateInfo: [
      {
        headline: '返信動画を録画する',
        content: '何度でも録画できます。動画は録画後すぐに保存されます。ビデオ面接には、メールで送信されるリンクから戻ることができます。',
        mobileContent: '何度でも録画できます。面接に動画を追加して下さい。アップロード中の動画や面接で保存された動画を確認できます。ビデオ面接には、メールで送信されるリンクから戻ることができます。<br><br><strong>もし動画が黒い画面のままで、Appleのモバイル端末をお使いの場合、問題の解決方法は<a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">こちらにあります</a>。</strong>',
      },
      {
        headline: '録画後、',
        content: '動画が正しく再生され、あなたの声が聞こえることを確認してください。「送信」ボタンを押すとあなたの返信はロックされ、編集できなくなります。',
      },
      {
        headline: '面接が終了したら、',
        content: '「返信して面接を終了する」ボタンを押して下さい。これ以降、ビデオ面接に戻ることはできません。このページを閉じた後で面接を続けたい場合は、「後で続ける」ボタンを押して下さい。',
      },
      {
        headline: 'ヘルプが必要な場合',
        content: mailto => `ビデオ面接に返信する時は、ページの右側にある「ヘルプ」ボタンをクリックするか、弊社までメールを送信してください：${mailto}。`,
        customContent: link => `連絡先 ${link}`,
      },
    ],

    navigationBar: {
      back: '戻る',
      dashboard: 'ダッシュボード',
      frontpage: 'フロントページ',
    },

    personDetails: {
      namePlaceholder: '候補者',
      stage: 'ステップ',
      contact: 'コンタクト',
      links: '参照リンク',
      attachments: '添付ファイル',
      coverLetter: 'PRメッセージ・カバーレター',
      referrer: 'アクセス元',
      referrerInfo: '応募者がアクセスしてきた元のサイト',
      noStage: 'どのステップにも進んでいません。',
      lastSeen: time => `最終閲覧： ${time}.`,
      headerAdditionalInformation: '追加情報',
      state: {
        invited: '案内済',
        visited: '閲覧有',
        incomplete: '未完了',
        completed: '完了',
      },
      notVisited: 'まだ面接画面を訪れていません。',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `他の役職でも ${count} 見つかりました。`,
    },

    phoneInput: {
      placeholder: example => `入力する電話番号形式  ${example}`,
    },

    typeSelect: {
      selected: '選択済み',
      change: '変更する',
    },

    questionsAndResponses: {
      response: '応答',
      noResponse: '応答なし',
      resetQuestionResponse: '志望者の回答を削除',
      resetQuestionResponseConfirm: questionTitle =>
        `志望者への質問"${questionTitle}"をリセットし、その回答を削除してもよろしいですか？`,
      resetQuestionResponseConfirm2:
        'これを実行すれば、志望者が再度この質問に回答することができます。',
    },

    rating: {
      ownVote: 'あなたの評価',
      yourVotePlaceholder: 'まだ投票していません。',
      totalVotes: count => `総合${count}評価`,
      mobileModalHeader: 'レイティングを追加',
      noRatings: 'まだノーレイティングです',
      yourRatingReset: '投票をリセットする',
      averageRating: '平均評価',
      reset: 'リセット',
    },

    share: {
      share: '共有する',
      copy: 'リンクをコピーする',
    },

    sort: {
      sort: '並べ替え',
    },

    video: {
      videoNotFound: '動画は処理中か、見つかりません',
      retry: '再度お試し下さい',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? '新しい動画をアップロードまたは録画する' : 'ファイルを選択する'),
      videoPlaceholder: '返信を録画する',
      uploadPlaceholderCandidate: 'ビデオのアップロード',
      submit: '返信する',
      notAnswered: 'まだ返信していません',
      remove: 'テイクの削除',
      converting: '動画を変換しています。お待ちください…',
      uploading: '動画をアップロードしています。お待ちください…',
      error: {
        invalid: '選択したファイルが大きすぎます。別のファイルを選択して下さい。',
        upload: '申し訳ございません、動画をアップロードすることができませんでした。再度お試し下さい。',
        transcode: '選択した動画ファイルは壊れているか無効です。再度お試し下さい。',
      },
    },

    virtualBg: {
      showMoreButtonText: '表示を増やす',
      showLessButtonText: '表示を減らす',
      infoText1:
        '録画中はタブを前面に置き、アクティブの状態にしてください。録画中は他のアプリケーションを使用しないでください。',
      infoText2:
        '背景動画の動画は、最新バージョンのブラウザと 新しい高性能なデバイスで最も効果的に動作します。',
      infoText3:
        '他のアプリケーションがマイクや カメラを使用中でないことを確認してください。',
    },

    videoResponse: {
      videoPlaceholder: 'あなたの回答を録画してください',
      uploadPlaceholder: 'ビデオのアップロード',
      submit: '回答を提出する',
      notAnswered: 'まだ回答を完了していません。',
      startInterview: '面接を開始する',
    },

    webcam: {
      useVideoBgButtonText: '動画背景を使用',
      removeVideoBgButtonText: '動画背景を削除',
      starting: '開始しています…',
      close: 'カメラを閉じる',
      remove: 'テイクの削除',
      record: '録画',
      stop: '停止',
      retake: '撮り直す',
      submit: '回答を提出する',
      converting: '動画を変換しています。お待ちください…',
      uploading: '動画をアップロードしています。お待ちください…',
      downloading: '動画をダウンロードしています。お待ちください…',
      processing: '処理しています…',
      uploadInProgress: '動画を転送中です。ブラウザを閉じたり別のページを開いたりしないで下さい。',
      uploaded: '動画を転送しました。',
      error: {
        DevicesNotFoundError: 'カメラまたはマイクが使用できません。有効であることを確認して下さい。',
        NotFoundError: 'カメラまたはマイクが使用できません。有効であることを確認して下さい。',
        NotAllowedError: 'カメラまたはマイクの使用を許可していませんでした。',
        PermissionDismissedError: '許可ダイアログが閉じられました。カメラとマイクの使用を許可してください。',
        PermissionDeniedError: 'カメラまたはマイクへのアクセスが拒否されました。',
        NotReadableError: 'カメラまたはマイクのストリームを読み込めません。ハードウェアの問題かもしれません。',
        SecurityError: 'セキュリティエラーによりカメラまたはマイクを使用できません。',
        stream: 'エラーが発生しました。ブラウザを再起動して下さい。それでも問題が継続する場合は、別のブラウザを試して下さい。',
        download: '動画のダウンロードに失敗しました。もう一度やり直しますか？',
        upload: '動画のアップロードに失敗しました。もう一度やり直しますか？',
        emptyBlob: 'ブラウザまたはデバイスのメモリがいっぱいで、録画できません。ページの再読み込みを行うか、それでも改善しない場合はブラウザを再起動して下さい。問題が継続する場合は、別のブラウザを試して下さい。',
        alternativeRecorder: 'これをクリックしてファイルをアップロードすることもできます。',
        reconnecting: 'インターネット接続が中断しました。もう一度接続してください。',
      },
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'LinkedInのプロフィールを表示する',
    },

    linkedInButton: {
      error: 'プロフィールの取得中にエラーが発生しました。もう一度お試しください。',
      buttonText: 'LinkedInへの申込み',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'LinkedInのプロフィールを使って応募フォームに事前入力できます',
      linkedInOr: 'または',
      error: 'プロフィールの取得中にエラーが発生しました。再度お試し下さい。',
    },

    linkListInput: {
      addField: '追加',
      removeField: '消去',
      invalidUrl: 'URLが有効ではありません。',
    },

    smsMessages: {
      invitationMessage: title =>
        `こんにちは！ビデオ面接の招待をお送りします。${title}! この招待はEメールにも送信しています。 `,
    },
  },
  page: {
    interviewPreview: {
      info: 'これは面接の予告です。録画は無効になっているため、フォームデータは保存されません。',
    },
  },
}
